import { Box } from "@mui/material"
import ContentSmall from "components/elements/ContentSmall"

const WalletPaymentTerms = () => {

    return (
        <Box display={'flex'} flexDirection={'column'} gap={1}>
            <ContentSmall
                languageKey="_PURCHASE_POINTS_TITLE_"
                fallbackText="Handelsbetingelser ved køb af point"
                style={{fontWeight: 600}}
            />

            <ContentSmall
                languageKey="_PURCHASE_POINTS_LINE_1_"
                fallbackText="Ved køb af point har du som forbruger 14 dages fortrydelsesret fra købstidspunktet, forudsat at pointene ikke er blevet anvendt."
            />

            <ContentSmall
                languageKey="_PURCHASE_POINTS_LINE_2_"
                fallbackText="Point anses for anvendt, når de helt eller delvist benyttes i forbindelse med et køb i webshoppen."
            />

            <ContentSmall
                languageKey="_PURCHASE_POINTS_LINE_3_"
                fallbackText="Hvis du anvender nogen af pointene, bortfalder din fortrydelsesret for købet af disse point."
            />

            <ContentSmall
                languageKey="_PURCHASE_POINTS_LINE_4_"
                fallbackText="Point kan ikke ombyttes til kontanter."
            />

            <ContentSmall
                languageKey="_PURCHASE_POINTS_LINE_5_"
                fallbackText="Hvis du gør brug af din fortrydelsesret, vil pointene blive annulleret, og det betalte beløb vil blive tilbagebetalt til den oprindelige betalingsmetode."
            />
        </Box>
    )
}

export default WalletPaymentTerms